function loadSliders() {
	$('.testimonials .carousel-inner').slick({
		centerMode: false,
		centerPadding: '0',
		slidesToShow: 1,
		prevArrow: "<button class='testimonials__button testimonials__button--prev' aria-label='Previous' type='button'><img src='https://bouncycastlenetwork-res.cloudinary.com/image/upload/v1785164120/Sites/gigis-castles/arrow-pink.png' alt=''/></button>",
		nextArrow: "<button class='testimonials__button testimonials__button--next' aria-label='Next' type='button'><img src='https://bouncycastlenetwork-res.cloudinary.com/image/upload/v1785164120/Sites/gigis-castles/arrow-pink.png' alt=''/></button>",
		autoplay: true,
		autoplaySpeed: 5000
	});

	$('.gallery__inner').slick({
		centerMode: false,
		centerPadding: '0',
		slidesToShow: 2,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 5000,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

}

var sliderScript = document.getElementById("deferredSlickScript");

sliderScript.addEventListener('load', function () {
	loadSliders();
});

$(document).ready(function () {

	$('.textContent a').addClass("has-tooltip");

	$("img.has-tooltip").tooltip({
		title: function () {
			return $(this).attr("alt");
		},
		placement: "auto"
	});

	$("a.has-tooltip").tooltip({
		placement: "auto"
	});


	// lazyload bg images - trigger needs data-sal="" attribute
	//var promisesBgTrigger = document.getElementById("lazyload-bg-trigger");
	//promisesBgTrigger.addEventListener('sal:in', () => {
	//	$('.bg-element').css("background-image", "url(" + CloudUrl + "bg-image.jpg)");
	//});

	

	// ADD SLIDEDOWN ANIMATION TO DROPDOWN //
	$('.toplinks').on('show.bs.dropdown', function (e) {
		$(this).find('.dropdown-menu').first().stop(true, true).slideDown();
		$("#TopLinksInner .dropdown-menu a").addClass("animated");
		window.scrollBy(0, 1);
	});

	// ADD SLIDEUP ANIMATION TO DROPDOWN //
	$('.toplinks').on('hide.bs.dropdown', function (e) {
		$(this).find('.dropdown-menu').first().stop(true, true).slideUp();
	});


	if ($('#HomepageMarker').length > 0) {

		// this removes the '/' between testimonial author & date if there are any testimonials
		// its difficult to style otherwise & is rarely wanted.
		var testimonialAuthors = $(".RotatorTestimonialContent a[itemprop='author']");
		if (testimonialAuthors.length > 0) {
			$(".RotatorTestimonialContent a[itemprop='author']").each(function () {
				$(this)[0].nextSibling.nodeValue = '';
			});
		}
		//$('.RotatorTestimonialContent').prepend('<div class="testimonials__stars"><img class="LazyLoadImage" data-src="/theme/stars.png" alt="" /></div>');

		// this is handy for staggered animations...
		// $('.many').each(function (i, el) {
		//	$(el).addClass('fadeInUp2').attr('some-attr', i / 5 + 's').attr('some-attr', '150');
		// });

		$('.header__logo').addClass("fadeInUp2");
	} else {
		$('.header__logo').css('visibility', 'visible');
	}

	function fixHeights() {
		$('.RotatorTestimonial').sameHeight();
		$('.featured-categories__title').sameHeight();
		if (window.matchMedia('(min-width:768px)').matches) {

		}
	}

	setTimeout(fixHeights, 300);


	$(window).on('resize',
		function () {
			setTimeout(fixHeights, 300);
		});


	//uncomment if sal.js in use & animations have been added after page load
	//scrollAnimations.update();
});

